import { Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './MealIngredients.styled';

type MealIngredientsProps = {
    ingredients?: {
        name: string;
        quantity: number | string;
        measure: string;
    }[];
    copy: {
        title: string;
    };
};

export const MealIngredients = ({ ingredients, copy }: MealIngredientsProps) => {
    if (!ingredients || ingredients.length === 0) {
        return null;
    }

    return (
        <S.Section data-locator="meal-ingredients-section" data-testid="meal-ingredients-section">
            <Text type="medium-text" medium>
                {copy.title}
            </Text>
            <S.Container data-locator="meal-ingredients" data-testid="meal-ingredients">
                {ingredients.map((ingredient, index) => (
                    <S.Item key={index}>
                        <Text type="small-text" bold={false}>
                            {ingredient.name}
                        </Text>
                        <Text type="option-subtitle-text" medium>
                            {ingredient.quantity} {ingredient.measure}
                        </Text>
                    </S.Item>
                ))}
            </S.Container>
        </S.Section>
    );
};
